import $ from "jquery"
import "slick-carousel-latest"
import "jquery-match-height";

$('.js-clients-slider').on('init', function(event, slick){
    //$('.js-clients-matchheight').matchHeight();
});

$('.js-clients-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
    ]
});

$('.js-clients-slider').on('afterChange', function(event, slick, currentSlide){
    //$('.js-clients-matchheight').matchHeight();
});

// benefits section
function sliderBenefitsSection() {
    var $slickBenefitsTitle = $('.js-benefits-title-slider');

    $slickBenefitsTitle.each(function() {
        var $sliderParent = $(this).parent();
        $(this).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.js-benefits-main-slider',
            dots: false,
            arrows: true,
            vertical: true,
            focusOnSelect: true,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        vertical: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        vertical: false,
                    }
                },
                {
                    breakpoint: 520,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        vertical: false,
                    }
                }
            ]
        });

        if ($(this).find('.item').length > 1) {
            $(this).siblings('.js-benefits-counter').show();
        }

        $(this).on('afterChange', function(event, slick, currentSlide){
            $sliderParent.find('.js-benefits-counter .js-benefits-counter-active').html(currentSlide + 1);
        });

        var sliderItemsNum = $(this).find('.slick-slide').not('.slick-cloned').length;
        $sliderParent.find('.js-benefits-counter .js-benefits-counter-total').html(sliderItemsNum);

    });
};

$('.js-benefits-main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.js-benefits-title-slider',
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'linear',
    swipe: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                adaptiveHeight: true,
            }
        }
    ]
});

sliderBenefitsSection();

// testimonials section
let $slickElement = $('.js-slider-testimonials');
let $status = $('.js-testimonials-counter');
$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    let i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + '/' + slick.slideCount);
});